module.exports = __webpack_public_path__ + "img/yanyun.a3ffe3bf.png";